import { memo, ReactElement } from 'react'

import isEqual from 'lodash/isEqual'

import { updateSovKeywords } from 'api/Cerebro/orgScoped/shareOfVoiceApi'
import { useResource } from 'components/EditableFields/localHooks'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions, useResourceOfPage } from 'hooks'
import { Label, SovFact } from 'types'

import { DeleteField } from '../../SharedFields/DeleteField'

interface Props<RecordType> {
    dataIndex: string[]
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function RemoveFromLabelField<RecordType extends SovFact>({
    dataIndex = ['keyword'],
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const hasLabelPermissions = useUserHasPermissions(
        userHasManageLabelsPermissions
    )

    const label: Label | null = useResourceOfPage('labelPage')

    const { getFromResource, resourceId } = useResource<RecordType>(
        record,
        dataIndex,
        'keyword'
    )

    const getIsDisabled = (): boolean => {
        const userCanManageKeyword = getFromResource(['user_can_manage'], true)
        return !hasLabelPermissions || !userCanManageKeyword || readOnly
    }

    return (
        <DeleteField
            disabled={getIsDisabled()}
            okText="Remove"
            title={`Are you sure you want to remove this keyword from ${label?.name}?`}
            updateRequestApi={updateSovKeywords}
            updateRequestCallback={reloadData}
            updateRequestData={{
                items: [{ id: resourceId, remove_label_ids: [label?.id] }],
            }}
            updateRequestSuccessMesg="SOV Keyword successfully removed"
        />
    )
}

export default memo(
    RemoveFromLabelField,
    isEqual
) as typeof RemoveFromLabelField
